<template>
  <div>
    <!-- Hero Section -->
    <div class="bg-gradient-to-r from-blue-600 to-indigo-700 text-white">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-32">
        <div class="text-center">
          <h1 class="text-4xl md:text-6xl font-extrabold tracking-tight mb-6">
            Innovative Open Solutions for Modern 4G/5G Networks
          </h1>
          <p class="text-xl md:text-2xl max-w-3xl mx-auto mb-10">
            Discover our cutting-edge open radio products designed to 4G/5G network
          </p>
          <div class="flex flex-col sm:flex-row justify-center gap-4">
            <router-link 
              to="/products" 
              class="px-8 py-4 bg-white text-blue-600 font-semibold rounded-lg shadow-lg hover:bg-gray-100 transition-colors"
            >
              Explore Products
            </router-link>
            <router-link 
              to="/contact" 
              class="px-8 py-4 bg-transparent border-2 border-white text-white font-semibold rounded-lg hover:bg-white hover:text-blue-600 transition-colors"
            >
              Contact Us
            </router-link>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Featured Products -->
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <h2 class="text-3xl font-bold text-center text-gray-900 mb-12">Featured Products</h2>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
        <ProductCard 
          v-for="product in featuredProducts" 
          :key="product.id"
          :product="product"
        />
      </div>
      <div class="text-center mt-12">
        <router-link 
          to="/products" 
          class="inline-block px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors"
        >
          View All Products
        </router-link>
      </div>
    </div>
    
    <!-- About Section -->
    <div class="bg-gray-50 py-16">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="lg:text-center">
          <h2 class="text-3xl font-bold text-gray-900 mb-4">About LioEdge</h2>
          <p class="text-lg text-gray-600 max-w-3xl mx-auto">
            We are a leading provider of innovative open technology solutions, committed to helping establish 
            customized 4G/5G network, to achieve their goals through cutting-edge products and exceptional service.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useMainStore } from '../store'
import ProductCard from '../components/ProductCard.vue'

const store = useMainStore()

const featuredProducts = computed(() => {
  return store.products.slice(0, 3)
})
</script>
